import { render, staticRenderFns } from "./license-tip.vue?vue&type=template&id=32fb189c"
import script from "./license-tip.vue?vue&type=script&lang=js"
export * from "./license-tip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports